module.exports = __webpack_public_path__ + "img/2.3a30a217.png";